<template>
  <CommonTip v-model="hintConfig">
    <div :class="['flex flex-wrap items-center gap-1']">
      <p :class="['lg:text-md text-sm']">{{ t('placeholder.notSupportLang') }}</p>
      <!-- 语言切换按钮 -->
      <UBadge
        v-for="item in suppLocaleList"
        :key="`supportLang-${item}`"
        variant="soft"
        size="sm"
        :ui="{ base: ['hover:cursor-pointer'] }"
        :icon="i18nLableConfig[item].icon"
        :label="i18nLableConfig[item].label"
        @click="setLocale(item)"
      />
    </div>
  </CommonTip>
</template>

<script lang="ts" setup>
  const { t, setLocale } = useI18n()
  const { isLangSupported } = useI18nContent()
  const { configSite } = useConfigStatic()

  /** 顶部提示组件数据 */
  const hintConfig = ref({
    isShow: !isLangSupported.value,
    icon: 'material-symbols:warning-outline',
  })

  /** 将'受支持的文章列表'格式化为'合法语言代码列表' */
  const suppLocaleList = configSite.ARTICLE_SUPP_LANGS.map(i =>
    useFormatContentLang(i),
  ) as LanguageCode[]
</script>
